// 将对象拼接成 key1=val1&key2=val2&key3=val3 的字符串形式

export function obj2params(obj) {
    let result = '';
    let item;
    for (item in obj) {
        if (obj[item] === "" || obj[item] === undefined) {
            continue;
        }
        result += '&' + item + '=' + encodeURIComponent(obj[item]);
    }

    if (result) {
        result = result.slice(1);
    }

    return result;
}

/**
 * 浅复制
 * @param p
 * @returns {{}}
 */
export function extendCopy(p) {
    let c = {};
    for (let i in p) {
        c[i] = p[i];
    }
    c.uber = p;
    return c;
}

export function urlEncode(param, key, encode) {
    if (param == null) return '';
    let paramStr = '';
    let t = typeof (param);
    if (t === 'string' || t === 'number' || t === 'boolean') {
        paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param);
    } else {
        for (let i in param) {
            // noinspection JSUnfilteredForInLoop
            let k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
            // noinspection JSUnfilteredForInLoop
            paramStr += urlEncode(param[i], k, encode);
        }
    }
    return paramStr;
}

export function getRequest() {
    let url = window.location.search; //获取url中"?"符后的字串
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        let strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}



// WEBPACK FOOTER //
// ./src/util/utils.js